export const openCallChatbot = (uuid) => {
  fetch(`${import.meta.env.VITE_APP_API_URL}/api/v1/metrics/open-chat`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ session: uuid }),
    }).then(response => {
      if (response.status === 200) {
      }
    }).catch(error => {
      console.error('Error sending open call', error);
    })
}
